import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M5 2C4.44772 2 4 2.44772 4 3V13C4 13.5523 4.44772 14 5 14H7C7.27614 14 7.5 14.2239 7.5 14.5C7.5 14.7761 7.27614 15 7 15H5C3.89543 15 3 14.1046 3 13V3C3 1.89543 3.89543 1 5 1H11C12.1046 1 13 1.89543 13 3V4.5C13 4.77614 12.7761 5 12.5 5C12.2239 5 12 4.77614 12 4.5V3C12 2.44772 11.5523 2 11 2H5ZM12.2087 10.5936C12.6895 10.2283 13 9.6504 13 9C13 7.89543 12.1046 7 11 7C9.89543 7 9 7.89543 9 9C9 9.6504 9.31046 10.2283 9.79128 10.5936C9.79715 10.5978 9.80292 10.6021 9.80859 10.6066C10.1414 10.8538 10.5536 11 11 11C11.4464 11 11.8586 10.8538 12.1914 10.6066C12.1971 10.6021 12.2029 10.5978 12.2087 10.5936ZM13 11.2361C13.6137 10.6868 14 9.8885 14 9C14 7.34315 12.6569 6 11 6C9.34315 6 8 7.34315 8 9C8 9.8885 8.38625 10.6868 9 11.2361V14.3613C9 14.7708 9.40122 15.06 9.78974 14.9305L11 14.527L12.2103 14.9305C12.5988 15.06 13 14.7708 13 14.3613V11.2361ZM12 11.8293C11.6872 11.9398 11.3506 12 11 12C10.6494 12 10.3128 11.9398 10 11.8293V13.8063L10.8103 13.5362C10.9334 13.4951 11.0666 13.4951 11.1897 13.5362L12 13.8063V11.8293Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
